<template>
    <div
        class="SearchBar"
    >
        <input
            v-model="searchTerm"
            type="text"
            :placeholder="placeholder"
            @input="$emit('update-search-term', $event.target.value)"
        >
        <BaseButton
            modifier="squared"
            tag="button"
            align="center"
        >
            <BaseIcon
                icon="search-icon"
                color="white"
            />
        </BaseButton>
    </div>
</template>
<script>
export default {
    name: 'SearchBar',
    props: {
        placeholder: {
            type: String,
            default: null
        }
    },
    data: () => ({
        searchTerm: null
    })
}
</script>
<style lang="scss" scoped>
    .SearchBar {
        display: flex;
        flex-grow: 1;
    }

    input {
        flex-grow: 1;
        border: none;
        border-bottom: 2px solid getColor('blue');
        font-size: 1rem;
    }

    .BaseButton {
        flex-shrink: 0;
        margin-left: getSpacing('small');
        font-size: 1rem;

        @include media-query(desk) {
            width: 60px;
            height: 60px;
            font-size: 1.1rem;
        }
    }
</style>
